import { motion } from "framer-motion";
import { Eyebrow, Reveal, EASE } from "./Reveal";

const STEPS = [
    { n: "01", title: "ASSESS", desc: "Understand your current ability, flexibility and goals." },
    { n: "02", title: "PLAN", desc: "Create a personalized training strategy." },
    { n: "03", title: "TRAIN", desc: "Develop strength, flexibility, technique and control." },
    { n: "04", title: "REFINE", desc: "Correct alignment and improve performance quality." },
    { n: "05", title: "PERFORM", desc: "Prepare for competition and perform with confidence." },
];

export default function Process() {
    return (
        <section id="journey" data-testid="process-section" className="relative bg-[#0A0A0A] py-20 sm:py-28 lg:py-32">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_100%,rgba(212,160,23,0.06),transparent_60%)]" />
            <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Eyebrow>The Coaching Journey</Eyebrow>
                <Reveal>
                    <h2 className="mt-6 font-display text-4xl tracking-wide sm:text-5xl lg:text-6xl">
                        FIVE STEPS TO THE <span className="text-gold-grad">PODIUM</span>
                    </h2>
                </Reveal>

                <div className="relative mt-16">
                    <div className="absolute left-[7px] top-0 h-full w-px bg-gradient-to-b from-[#F5C542]/60 via-[#D4A017]/25 to-transparent md:left-0 md:top-[26px] md:h-px md:w-full md:bg-gradient-to-r" />
                    <div className="grid gap-10 md:grid-cols-5 md:gap-5">
                        {STEPS.map((s, i) => (
                            <motion.div
                                key={s.n}
                                data-testid={`process-step-${s.n}`}
                                className="relative pl-10 md:pl-0"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
                            >
                                <span className="absolute left-0 top-1.5 flex h-[15px] w-[15px] items-center justify-center rounded-full border border-[#F5C542]/70 bg-[#050505] md:relative md:top-0 md:mb-6 md:h-4 md:w-4">
                                    <span className="h-[5px] w-[5px] rounded-full bg-[#F5C542]" />
                                </span>
                                <p className="font-display text-5xl text-transparent leading-none" style={{ WebkitTextStroke: "1px rgba(212,160,23,0.55)" }}>
                                    {s.n}
                                </p>
                                <h3 className="mt-3 font-display text-2xl tracking-[0.12em] text-white">
                                    {s.title}
                                </h3>
                                <p className="mt-2.5 text-[13px] leading-relaxed text-[#B8B8B8]">
                                    {s.desc}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
